<div *ngIf="!isDesktop" class="page-layout carded left-sidenav toolbar-fixed-layout flex flex-col justify-start items-center">
  <div class="text-wrapper flex flex-row justify-between items-center">
    <span class="title">Orbitax Desktop</span>
    <span class="description-text">Please download the Orbitax Desktop application where you can continue using International
Tax Platform tools along with improved performance, enhanced Entity Designer and more.</span>
  </div>
  <!--  <input id="toDetectProtocolUrl" #refEl (blur)="detectedProtocol()" style="opacity: 0;width: 1px;height: 1px">-->

  <div class="package-details flex flex-col justify-start items-center">
    <button mat-button class="action-button" (click)="download()">
      <i class="far fa-arrow-to-bottom"></i>
      Download Orbitax Desktop
    </button>
    <div class="install-text">
      <span class="p-r-3">Already installed?</span>
      <a class="pointer" (click)="runProtocolDesktop()">Launch Orbitax Desktop</a>
    </div>
    <img src="https://orbitaxservices.com/orbitax-assets/images/orbitax-images/Orbitax_Drive_Screenshot.svg" width="700px"/>
  </div>

</div>


<!--<div class="page-layout carded left-sidenav toolbar-fixed-layout" >-->
<!--  <input id="toDetectProtocolUrl" #refEl (blur)="detectedProtocol()" style="opacity: 0;width: 1px;height: 1px">-->
<!--  <mat-sidenav-container>-->

<!--    &lt;!&ndash; CENTER &ndash;&gt;-->
<!--    <div class="center">-->

<!--      &lt;!&ndash; CONTENT CARD &ndash;&gt;-->
<!--      <div class="content-card">-->
<!--        &lt;!&ndash; CONTENT TOOLBAR &ndash;&gt;-->



<!--        <div class="content m-30" fxLayout="column" fusePerfectScrollbar>-->
<!--          <table>-->
<!--            <tr>-->
<!--              <td title="Orbitax Web">-->
<!--                <div fxLayout="column" class="package-details" >-->
<!--                  <particle-demo-tutorial-tip *ngIf="demoHistory"-->
<!--                                              [toolTipKey] = "toolTipKey3a">-->
<!--                  </particle-demo-tutorial-tip>-->
<!--                  <div class="package-title">Orbitax <span>Web</span></div>-->
<!--                  <div class="characteristic">Lightweight and browser-based</div>-->
<!--                  <button mat-button class="action-button" disabled>Launch Orbitax Web <i class="far fa-arrow-right"></i></button>-->
<!--                </div>-->
<!--              </td>-->
<!--              <td title="Orbitax Desktop">-->
<!--                <div fxLayout="column" class="package-details">-->
<!--                  <particle-demo-tutorial-tip *ngIf="demoHistory" [toolTipKey] = "toolTipKey3c">-->
<!--                  </particle-demo-tutorial-tip>-->
<!--                  <div class="package-title">Orbitax <span>Desktop</span></div>-->
<!--                  <div class="characteristic">Feature-rich desktop calculator</div>-->

<!--                  <button mat-button class="action-button" (click)="runProtocolDesktop()">-->
<!--                    Launch Orbitax Desktop-->
<!--                    <i class="far fa-arrow-right"></i>-->
<!--                  </button>-->
<!--                  <div class="install-text">-->
<!--                    <span class="p-r-3">First Time?</span>-->
<!--                    <a class="pointer" (click)="download()">Download Orbitax Desktop</a>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;                  <div *ngIf="!isAlreadyAppInstalled" class="note">&ndash;&gt;-->
<!--                  &lt;!&ndash;                    <span>Note:</span> Your Designer Pro download should start automatically in a few seconds...If it doesn't <a class="pointer" (click)="download()">please click here to start</a>&ndash;&gt;-->
<!--                  &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--                </div>-->

<!--              </td>-->
<!--              &lt;!&ndash;</tr>-->
<!--              <tr>-->
<!--                <td>Add custom entity fields</td>-->
<!--                <td title="Designer Lite"><i class="far fa-check"></i></td>-->
<!--                <td title="Designer Pro"><i class="far fa-times"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Import and export to Excel</td>-->
<!--                <td title="Designer Lite"><i class="far fa-check"></i></td>-->
<!--                <td title="Designer Pro"> Only Export</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Drag & drop entities on chart</td>-->
<!--                <td title="Designer Lite"><i class="far fa-check"></i></td>-->
<!--                <td title="Designer Pro"><i class="far fa-times"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Conditional entity formatting</td>-->
<!--                <td title="Designer Lite">Limited</td>-->
<!--                <td title="Designer Pro"> <i class="far fa-check"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Multiple chart layouts</td>-->
<!--                <td title="Designer Lite"><i class="far fa-check"></i></td>-->
<!--                <td title="Designer Pro"> <i class="far fa-check"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Edit entity label contents</td>-->
<!--                <td title="Designer Lite"><i class="far fa-check"></i></td>-->
<!--                <td title="Designer Pro"> <i class="far fa-check"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Create slides by entity filter</td>-->
<!--                <td title="Designer Lite"><i class="far fa-check"></i></td>-->
<!--                <td title="Designer Pro"> <i class="far fa-check"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Refresh all filtered slides</td>-->
<!--                <td title="Designer Lite"><i class="far fa-times"></i></td>-->
<!--                <td title="Designer Pro"> <i class="far fa-check"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Minority ownership display options</td>-->
<!--                <td title="Designer Lite">Limited</td>-->
<!--                <td title="Designer Pro"> <i class="far fa-check"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Add legends, notes and images</td>-->
<!--                <td title="Designer Lite">No images</td>-->
<!--                <td title="Designer Pro"><i class="far fa-check"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Various print and export options</td>-->
<!--                <td title="Designer Lite">PDF only</td>-->
<!--                <td title="Designer Pro"> <i class="far fa-check"></i></td>-->
<!--              </tr>-->
<!--              &lt;!&ndash;            <tr>-->
<!--                            <td>Generate entity chart playbook</td>-->
<!--                            <td title="Designer Lite"><i class="far fa-times"></i></td>-->
<!--                            <td title="Designer Pro"> <i class="far fa-check"></i></td>-->
<!--                          </tr>&ndash;&gt;-->
<!--              <tr>-->
<!--                <td>Add payment transactions</td>-->
<!--                <td title="Designer Lite"><i class="far fa-times"></i></td>-->
<!--                <td title="Designer Pro"><i class="far fa-times"></i></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>Display payment transactions</td>-->
<!--                <td title="Designer Lite"><i class="far fa-times"></i></td>-->
<!--                <td title="Designer Pro"> <i class="far fa-check"></i></td>-->
<!--              </tr>&ndash;&gt;-->
<!--          </table>-->
<!--        </div>-->


<!--      </div>-->
<!--      &lt;!&ndash; / CONTENT CARD &ndash;&gt;-->

<!--    </div>-->
<!--    &lt;!&ndash; / CENTER &ndash;&gt;-->

<!--  </mat-sidenav-container>-->

<!--</div>-->
